import classNames from "classnames";
import styles from "./AscHowItWorksCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import AscTag from "../../AscTag/AscTag";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";

export interface AscAscHowItWorksCardProps {
  className?: string;
  steps: string[];
}

export default function AscHowItWorksCard({
  className,
  steps,
}: AscAscHowItWorksCardProps) {
  return (
    <AscGenericCard
      title="How does the job board work"
      data-testid="asc-how-it-works-card"
      className={classNames(styles.ground, className)}
      coverImageUrl={null}
      titleClassName={styles.title}
      bodyClassName={styles.body}
      contentClassName={styles.content}
    >
      <div className={styles.steps}>
        {steps?.map((step, index) => (
          <div className={styles.stepItem}>
            <AscTag
              key={index}
              label={++index}
              type="card-brand-orange"
              className={styles.icon}
            />
            <AscParagraph className={styles.text}>{step}</AscParagraph>
          </div>
        ))}
      </div>
    </AscGenericCard>
  );
}
